import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCabinet: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCabinet"><Path d="M11 4H2V12H3.92448L2.87661 19.8591L4.85906 20.1234L5.94218 12H11V4Z" fill="currentColor"/><Path d="M13 12H18.0578L19.1409 20.1234L21.1234 19.8591L20.0755 12H22V4H13V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCabinet;
